module.exports = __webpack_public_path__ + "static/img/Christian-Petracca.439b96e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Christian-Petracca.jpg
// module id = o6Lv
// module chunks = 0